import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { useExecuteAction } from 'components/hooks/connect_hooks';
import ConversationItem from 'models/conversation_item';
import NavigateToItem from 'actions/conversation_item/navigate_to_item';
import { iconClassNameForItem } from '../metadata/metadata_icon_classes';
import ItemContent from '../item_content';
import { ACTOR_PHRASES } from '../metadata/actor_sentence';
import AgentMetadata from '../metadata/agent_metadata';

export default function TaskEditedItem({ item }) {
  const executeAction = useExecuteAction();
  // The anchor carries an href so it lands in the tab order; navigation is
  // handled by the action, so the fragment jump is suppressed.
  const onClick = useCallback(
    e => {
      e.preventDefault();
      executeAction(NavigateToItem, { customerId: item.customerId, itemId: item.content.taskItemId });
    },
    [item.customerId, item.content.taskItemId]
  );

  return (
    <ItemContent isAuditItem item={item}>
      <AgentMetadata
        iconClass={iconClassNameForItem(item)}
        item={item}
        phrase={ACTOR_PHRASES.EDITED_TASK}
        phraseComponents={{
          taskLink: (
            <a
              className="taskEditedItem-link itemMetadata-subject"
              href={`#conversationItem-${item.content.taskItemId}`}
              onClick={onClick}
            />
          ),
        }}
      />
    </ItemContent>
  );
}

TaskEditedItem.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};
